import { Injectable, Output, EventEmitter, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { TypeVehicleMap,TypeVehicleUserData } from '../models/interfaces';
import moment, { Moment } from 'moment';
import { UserIconsService } from './user-icons.service';
import { IVehicleIcon, IUserVehicleIcon, ItemIcon } from '../models/interfaces';


@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  svgContents: { [key: string]: string } = {}; // Almacena los contenidos de los SVG
  svgContentsSafe: { [key: string]: SafeHtml } = {}; // Almacena los contenidos seguros de los SVG
  svgContentsGreenSafe: { [key: string]: SafeHtml } = {}; // Almacena los contenidos seguros de los SVG
  svgContentsBlueSafe: { [key: string]: SafeHtml } = {}; // Almacena los contenidos seguros de los SVG
  svgContentsRedSafe: { [key: string]: SafeHtml } = {}; // Almacena los contenidos seguros de los SVG

  userData: any = {};
  userName: string = '';
  userEmail: string = '';
  companyName: string = '';
  userDataInitialized: boolean = false;
  userConfigDataInitialized: boolean = false;
  apiUrl = environment.apiUrl;
  typeVehicles: any = {}; // deprecate
  typeVehiclesUserData: any = {}; // deprecate
  userPermissionData: string[] = [];
  changeItemIcon: string = ''; // deprecate

  reportsUser: any;
  eventsUser: any;
  reportsUserLoaded: boolean = false;
  changeRotateIcon: boolean = false; // deprecate
  tailActive: boolean = false;
  nroPointsTail: number = 0;

  stateVehiclesDirectionSvg: boolean = false; // deprecate
  stateCustomDirectionSvg: boolean = false; // deprecate 

  @Output() userDataCompleted = new EventEmitter<any>();
  @Output() geofencesPrivileges = new EventEmitter<any>();
  @Output() geopointsPrivileges = new EventEmitter<any>();

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public spinner: NgxSpinnerService,
    public userIconsService : UserIconsService
  ) {}

  public async getUserData() {
    console.log('USER DATA SERVICE LOADING');
    //tambien llamamos los tipos de vehicles
    this.http.post<any>(environment.apiUrl + '/api/userData', {}).subscribe({
      next: async (data) => {
        //this.userData = this.panelService.userData = data[0];
        console.log('User Data InfoXD ->: ', data);
        // console.log('User Data obtenida ======> ',  data.data);
        // console.log('User VEHICLES obtenida ======> ',  data.data2);
        // console.log('User CONFIG DATA obtenida ======> ',  data.data3);
        
        // this.typeVehicles = await data.data2;
        // this.typeVehiclesUserData = await data.data3;
        // this.userPermissionData = await data.data4;
        // localStorage.setItem('PermissionList', JSON.stringify( await data.data4));

        this.setUserInfo(data)

        // this.changeItemIcon =  this.getChangeItemColor();
        // this.changeRotateIcon = await this.userData.bol_direction;
        this.tailActive = this.userData.bol_tail;
        this.nroPointsTail = this.userData.nro_points_tail;
        
        await this.userIconsService.initializeVehicles(
          data.data2 as IVehicleIcon[] , 
          data.data3 as IUserVehicleIcon[], 
          this.getChangeItemColor() as ItemIcon,
          await this.userData.bol_direction
        )

        //await this.setTypeVehicles();

        console.log("VEHICULOS GENERADOS...")

        this.spinner.hide('loadingAlertData'); // Nombre opcional, puedes usarlo para identificar el spinner
        console.log('USER DATA SERVICE LOADED');

        this.emitDataReady()

        console.log('vehicle');
      },
      error: (errorMsg) => {
        console.log('No se pudo obtener datos del usuario', errorMsg);
      },
    });
  }
  private setUserInfo(data: any) {
    this.userData = data.data
    this.userName = data.data.nombre_usuario
          .normalize('NFKD')
          .replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@]+/g, '')
          .replace(/  +/g, ' ')
          .trim();
    this.userPermissionData = data.data4;
    this.userEmail = data.data.var_email;
    this.companyName = data.data.var_nombre_comercial;
    this.userDataInitialized = true;
    localStorage.setItem('Privilegios', data.data.privilegios);
    localStorage.setItem('PermissionList', JSON.stringify( data.data4));

    console.log('USER DATA SERVICE LOADED');
  }
  private emitDataReady() {
    this.userDataCompleted.emit(true);
    this.geofencesPrivileges.emit(true);
    this.geopointsPrivileges.emit(true);
    console.log('vehicle');
  }
  
  public getReportsForUser(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/getPermissReports`);
  }
  public updateUserConfig(updatedUserConfig: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/userconfig`,updatedUserConfig);
  }
  public changePasswordUser(infoUser: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/changePassword`, infoUser);
  }

  get firstLetter() {
    let letter = this.userName.charAt(0);
    if (letter === letter.toLowerCase()) {
      return letter.toUpperCase();
    }
    return letter;
  }

  //FUNCION PARA SABER SI EL VEHICULO CAMBIA ESTADO O NO
  public getChangeItemColor(): ItemIcon {
    if (this.userData.bol_ondas) return ItemIcon.ONDAS;
    if (this.userData.bol_vehicle) return ItemIcon.VEHICLES;
    if (this.userData.bol_cursor) return ItemIcon.CURSOR;
    
    return ItemIcon.NULL;
  }

  async setDefaultStatusUserData() {
    this.userDataInitialized = false;
  }

}
